// Navbar.js
import React, { useState } from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import {
  Diamond,
  Link as LinkIcon,
  Monitor,
  MessagesSquare,
  HelpCircle,
  Menu,
  X,
} from "lucide-react";
import "./Navbar.css";
import TokenRacingLogo from "../assets/TokenRacingLogo.png";

const NavLink = ({ to, icon, text, isActive, onClick }) => {
  return (
    <Link
      to={to}
      className={`nav-link ${isActive ? "active" : ""}`}
      onClick={onClick}
    >
      <span className="nav-link-content">
        {icon}
        <span className="nav-link-text">{text}</span>
      </span>
    </Link>
  );
};

NavLink.propTypes = {
  to: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  text: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};

const Navbar = () => {
  const location = useLocation();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const isActive = (path) => {
    return location.pathname === path;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    // Prevent body scroll when menu is open
    document.body.style.overflow = !isMenuOpen ? "hidden" : "unset";
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
    document.body.style.overflow = "unset";
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-content">
          <div className="logo-container">
            <Link to="/" className="logo-link">
              <div className="logo-wrapper">
                <img
                  src={TokenRacingLogo}
                  alt="TokenRacing"
                  className="logo-image"
                />
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <div className="nav-links desktop-nav">
            <NavLink
              to="/race-wizard"
              icon={<Diamond className="nav-icon" />}
              text="Race Wizard"
              isActive={isActive("/race-wizard")}
            />
            <NavLink
              to="/join-races"
              icon={<LinkIcon className="nav-icon" />}
              text="Join Races"
              isActive={isActive("/join-races")}
            />
            <NavLink
              to="/watch"
              icon={<Monitor className="nav-icon" />}
              text="Watch"
              isActive={isActive("/watch")}
            />
            <NavLink
              to="/faq"
              icon={<HelpCircle className="nav-icon" />}
              text="Docs"
              isActive={isActive("/faq")}
            />
          </div>

          {/* Mobile Hamburger Menu */}
          <button className="mobile-menu-button" onClick={toggleMenu}>
            {isMenuOpen ? (
              <X className="nav-icon" />
            ) : (
              <Menu className="nav-icon" />
            )}
          </button>

          {/* Mobile Navigation Menu */}
          <div className={`mobile-nav ${isMenuOpen ? "open" : ""}`}>
            <div className="mobile-nav-content">
              <NavLink
                to="/race-wizard"
                icon={<Diamond className="nav-icon" />}
                text="Race Wizard"
                isActive={isActive("/race-wizard")}
                onClick={closeMenu}
              />
              <NavLink
                to="/join-races"
                icon={<LinkIcon className="nav-icon" />}
                text="Join Races"
                isActive={isActive("/join-races")}
                onClick={closeMenu}
              />
              <NavLink
                to="/watch"
                icon={<Monitor className="nav-icon" />}
                text="Watch"
                isActive={isActive("/watch")}
                onClick={closeMenu}
              />
              <NavLink
                to="/faq"
                icon={<HelpCircle className="nav-icon" />}
                text="FaQ"
                isActive={isActive("/faq")}
                onClick={closeMenu}
              />
              <NavLink
                to="/support"
                icon={<MessagesSquare className="nav-icon" />}
                text="Support"
                isActive={isActive("/support")}
                onClick={closeMenu}
              />
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
